<ng-template #stepLines let-step>
  <div class="ou-step">
    <span class="ou-step__key">{{ step.stepKey }}</span>
    <span class="ou-step__title">{{ step.stepTitle }}</span>
  </div>
  <ul class="ou-lines">
    @for (line of step.lines; track $index) {
      <li class="ou-line" data-testid="ou-line">
        <span class="ou-line__number">
          @if (line.lineNumber !== null) {
            {{ 'objectMappings.usages.line' | translate }} {{ line.lineNumber }}
          } @else {
            {{ 'objectMappings.usages.stepCondition' | translate }}
          }
        </span>
        @if (line.newText) {
          <span class="ou-line__change">
            <code class="ou-code ou-code--old" data-testid="ou-old">
              <span class="sr-only">{{ 'objectMappings.usages.oldText' | translate }}</span>
              {{ line.text }}
            </code>
            <code class="ou-code ou-code--new" data-testid="ou-new">
              <span class="sr-only">{{ 'objectMappings.usages.newText' | translate }}</span>
              {{ line.newText }}
            </code>
          </span>
        } @else {
          <code class="ou-code">{{ line.text ?? line.reference }}</code>
        }
      </li>
    }
  </ul>
</ng-template>

@if (duplicatesHint(); as hint) {
  <p class="ou-duplicates" role="note" data-testid="ou-duplicates">{{ hint.key | translate: hint.params }}</p>
}

@if (empty()) {
  <p class="ou-empty" data-testid="ou-empty">{{ 'objectMappings.usages.empty' | translate }}</p>
} @else {
  @if (usages().testCases.length > 0) {
    <section class="ou-group">
      <h3 class="ou-group__title">{{ 'objectMappings.usages.testCases' | translate }}</h3>
      @for (owner of usages().testCases; track owner.id) {
        <div class="ou-owner" data-testid="ou-test-case">
          <a class="ou-owner__link" [routerLink]="['/projects', projectId(), 'test-cases', owner.id, 'edit']">
            <span class="ou-owner__key">{{ owner.key }}</span>
            {{ owner.title }}
          </a>
          @for (step of owner.steps; track step.stepId) {
            <ng-container *ngTemplateOutlet="stepLines; context: { $implicit: step }" />
          }
        </div>
      }
    </section>
  }
  @if (usages().modules.length > 0) {
    <section class="ou-group">
      <h3 class="ou-group__title">{{ 'objectMappings.usages.modules' | translate }}</h3>
      @for (owner of usages().modules; track owner.id) {
        <div class="ou-owner" data-testid="ou-module">
          <a class="ou-owner__link" [routerLink]="['/projects', projectId(), 'test-modules', owner.id, 'edit']">
            <span class="ou-owner__key">{{ owner.key }}</span>
            {{ owner.title }}
          </a>
          @for (step of owner.steps; track step.stepId) {
            <ng-container *ngTemplateOutlet="stepLines; context: { $implicit: step }" />
          }
        </div>
      }
    </section>
  }
  @if (usages().unlinkedSteps.length > 0) {
    <section class="ou-group">
      <h3 class="ou-group__title">{{ 'objectMappings.usages.unlinkedSteps' | translate }}</h3>
      @for (step of usages().unlinkedSteps; track step.stepId) {
        <div class="ou-owner" data-testid="ou-unlinked">
          <a class="ou-owner__link" [routerLink]="['/projects', projectId(), 'test-steps', step.stepId, 'edit']">
            <span class="ou-owner__key">{{ step.stepKey }}</span>
            {{ step.stepTitle }}
          </a>
          <ng-container *ngTemplateOutlet="stepLines; context: { $implicit: step }" />
        </div>
      }
    </section>
  }
}
